<button
    class="btn btn-sm btn-outline-secondary"
    (click)="resendInvitation($event)"
>
    <nb-icon icon="fa-paper-plane"></nb-icon>
</button>
